<template lang="pug">
.do-MYOFFICE
  .roomTitle(v-once) {{$attrs.cont.departmentName}}
    div.tl().point
    div.tr().point
    div.bl().point
    div.br().point
  ArrControl(v-if='sceneState',:cont='EliminateControl[AssessmentIndex]',@Determine='Determine',:tsIndex="tsIndex",:Boer="Boer")
  Documents(v-if='filecontent',@ok='Close')
  ul.list
    li(v-for='v in list',@click='query(v.id,v.taskseq,v.taId,v.taskseq == v.taskIndex, v.complete)')
      i.icon-labelb.iconfont.icon
      | {{v.functionName}}
      <Icon type="md-checkmark" v-if="v.complete" color="#42b983" class="point check"/>
      aBadge.point(dot,v-else-if='!v.complete && v.taskseq == v.taskIndex')
      aBadge.point.unstart(dot,v-else-if='(!v.complete && v.taskseq != v.taskIndex) && v.id' color="#000000")
</template>
<script>
import ArrControl from "@/components/doCase/doControl/ArrControl"; // 欢迎进入控件
import Documents from "@/components/doCase/Myoffice/Documents"; // 我的文档

import { Badge } from "ant-design-vue-findsoft";

export default {
  components: {
    ArrControl,
    Documents,
    aBadge: Badge
  },
  data() {
    return {
      AloneControl: ["MATERIALANALYSISPROBLEM", "PICTURETEXT"],
      sceneState: false,
      step: ["FORMULATE", "EXECUTE", "ASSESS", "FINALITY"],
      filecontent: false,
      sceneControlList: [],
      AssessmentIndex: 0,
      cont: this.$attrs.cont,
      filecontentIndex: 0,
      EliminateControl: [],
      index: 0,
      list: [],
      subjectIndex: -1,
      tsIndex: -1,
      Boer: false,
      tsId: null
    };
  },
  methods: {
    Determine() {
      console.sun(333333);

      if (this.AssessmentIndex < this.EliminateControl.length - 1) {
        this.AssessmentIndex += 1;
        return;
      }
      this.sceneState = false;
      console.sun(22222222);
      this.$http
        .mergerTaskScenarioRelation({
          complete: true,
          taskScenarioId: this.tsId,
          userId: this.$role.code,
          experimentId: this.$store.state.doCase.experimentId
        })
        .then(() => {
          const find = value => {
            return value.departmentName === "我的办公室";
          };
          console.log(this.cont);
          const data = {
            cdId: this.$parent.hallList.find(find).chId,
            userId: this.$role.code,
            experimentId: this.$store.state.doCase.experimentId
          };
          this.$http.listMyOffice(data).then(res => {
            this.list = [];
            res.data.data.forEach(async (v, index) => {
              // await this.query(v.id, v.taskseq, v.taId, v.taskseq === v.taskIndex);
              this.list.push(v);
              if (index === res.data.data.length - 1) {
                this.list.push({ functionName: "我的文档", id: null });
                this.list.forEach(item => {
                  this.$set(item, "taskIndex", this.$parent.taskIndex);
                });
              }
            });
          });
        });
      if (this.$parent.taskIndex === this.subjectIndex) {
        console.sun(111111111);
        this.$emit("addOne", this.index);
      }
    },
    // Determine() {
    //   // 关闭

    //   if (this.EliminateControl.length > this.controList + 1) {
    //     this.control = false;
    //     this.controList += 1;
    //     setTimeout(() => {
    //       this.control = this.EliminateControl[this.controList].type;
    //     }, 300);
    //   } else {
    //     this.$emit("SignOut");
    //   }
    // },
    Close() {
      this.filecontent = false;
    },
    query(id, index, taId, Boer, Complete) {
      this.tsId = id;
      this.Boer = Boer;
      if (!id) {
        // eslint-disable-next-line no-return-assign
        return (this.filecontent = true);
      }
      if (!Complete && !Boer) {
        this.$Message.warning("未到达该任务，请先完成当前步骤。");
        return false;
      }
      // if (index > this.$parent.taskIndex) {
      //   return this.$Message.error("暂未开启");
      // }
      this.subjectIndex = index;
      const sdata = {
        tsId: id
      };
      this.$http.listControlByTsid(sdata).then(res => {
        console.log("场景里的空间", res);
        if (res.data.data.length === 0) {
          this.$Message.error("此阶段没有题目,可直接返回场景进行下一步!");
          this.Determine();
        }
        this.sceneControlList = res.data.data;
        if (this.sceneControlList.length !== 0) {
          const contList = [];
          let data = [];
          let num = 0;
          this.sceneControlList.forEach((element, idx) => {
            if (num === +element.pageNumber) {
              if (this.AloneControl.indexOf(element.type) === -1) {
                data.push(element);
                if (idx === this.sceneControlList.length - 1) {
                  if (data.length !== 0) {
                    contList.push(data);
                  }
                }
              } else {
                if (data.length !== 0) {
                  contList.push(data);
                }
                contList.push(element);
                data = [];
              }
            } else if (this.AloneControl.indexOf(element.type) === -1) {
              if (data.length !== 0) {
                contList.push(data);
              }
              data = [];
              data.push(element);
              if (idx === this.sceneControlList.length - 1) {
                contList.push(data);
              }
            } else {
              if (data.length !== 0) {
                contList.push(data);
              }
              contList.push(element);
              data = [];
            }
            num = +element.pageNumber;
          });
          console.log(id);
          console.log(this.$parent.taskList);
          this.cont.id = this.$parent.taskList.find(value => {
            return value.id === taId;
          }).id;
          this.EliminateControl = contList;
          this.AssessmentIndex = 0;
          this.sceneState = true;
          console.log(this.EliminateControl);
        }
      });
    },
    queryg() {
      // const data = {
      //   caseHallId: this.$store.state.doCase.caseData[
      //     this.step[this.$parent.index]
      //   ].tsId,
      //   experimentId: this.$store.state.doCase.experimentId
      // };
      // this.$http.queryTaskByStu(data).then(res => {
      //   res.data.data.forEach(item => {
      //     const find = value => {
      //       return value.taId === item.id;
      //     };
      //     console.sun(this.list.find(find));
      //     if (this.list.find(find) && item.complete) {
      //       this.$set(this.list.find(find), "yes", true);
      //     }
      //   });
      // });
    }
  },
  created() {
    this.index = this.$parent.taskIndex;
    const find = value => {
      return value.departmentName === "我的办公室";
    };
    console.log(this.cont);
    const data = {
      cdId: this.$parent.hallList.find(find).chId,
      userId: this.$role.code,
      experimentId: this.$store.state.doCase.experimentId
    };
    this.$http.listMyOffice(data).then(res => {
      // console.log(this);
      // console.log(res);
      // const temp = Object.assign([], res.data.data);
      // temp.push({ functionName: "我的文档", id: null });
      // temp.forEach(v => {
      //   this.list.push(v);
      //   this.$set(v, "taskIndex", this.$parent.taskIndex);
      // });
      res.data.data.forEach(async (v, index) => {
        // await this.query(v.id, v.taskseq, v.taId, v.taskseq === v.taskIndex);
        this.list.push(v);
        this.$set(v, "taskIndex", this.$parent.taskIndex);
        if (index === res.data.data.length - 1) {
          this.list.push({ functionName: "我的文档", id: null });
          this.list.forEach(item => {
            this.$set(item, "taskIndex", this.$parent.taskIndex);
          });
        }
      });
    });
  }
};
</script>

<style lang="stylus" scoped>
.do-MYOFFICE
  position absolute
  background url('../../../assets/case/department/myOffice.png')
  background-size 100vw
  height 100vh
  width 100vw
  z-index 5
  .roomTitle
    position absolute
    top 76px
    left 0
    right 0
    margin 0 auto
    width 150px
    height 40px
    background-color rgba(245, 166, 35, 1)
    border-radius 4px
    opacity 0.8022
    font-size 18px
    font-family fzhpfw
    font-weight normal
    color rgba(255, 255, 255, 1)
    line-height 40px
    .point
      width 4px
      height 4px
      background rgba(255, 255, 255, 1)
      border-radius 2px
      opacity 0.3043
      &:nth-child(1)
        position absolute
        top 4px
        left 6px
      &:nth-child(2)
        position absolute
        top 4px
        right 6px
      &:nth-child(3)
        position absolute
        top 30px
        left 6px
      &:nth-child(4)
        position absolute
        top 30px
        right 6px
  .list
    display flex
    height 80%
    position absolute
    top 0
    bottom 0
    margin auto
    left 145px
    flex-flow column
    .icon
      color #FF9F00
      font-size 24px
      margin-left 15px
      margin-right 15px
    li
      margin-bottom 16px
      cursor pointer
      width 220px
      text-align left
      height 48px
      background rgba(220, 230, 242, 1)
      box-shadow 0px 1px 4px 0px rgba(0, 0, 0, 0.2)
      border-radius 8px
      font-size 16px
      font-family MicrosoftYaHeiUI
      color rgba(42, 46, 54, 0.8)
      line-height 48px
      position relative
  .point
    position absolute
    right 20px
    top 23px
  .unstart
    top 17px
    right 10px
  .check
    right 11px
    top 17px
</style>
